module.exports = __webpack_public_path__ + "img/banner7.849d911a.png";